import React from 'react';
import {
  Activity, UserPlus, FileCheck, BookOpen, Calendar, ClipboardCheck, Award,
  Upload, ShieldCheck, StickyNote, Mail, MessageCircle, Users, ThumbsUp, Send,
  CornerUpLeft, CheckCircle, XCircle, PartyPopper, FileText, GraduationCap, Folder,
  FolderCheck, Pause, Edit,
} from 'lucide-react';

const ICONS = {
  activity: Activity, 'user-plus': UserPlus, 'file-check': FileCheck, 'book-open': BookOpen,
  calendar: Calendar, 'clipboard-check': ClipboardCheck, award: Award, upload: Upload,
  'shield-check': ShieldCheck, 'sticky-note': StickyNote, mail: Mail, 'message-circle': MessageCircle,
  users: Users, 'thumbs-up': ThumbsUp, send: Send, 'corner-up-left': CornerUpLeft,
  'check-circle': CheckCircle, 'x-circle': XCircle, 'party-popper': PartyPopper,
  'file-text': FileText, 'graduation-cap': GraduationCap, folder: Folder,
  'folder-check': FolderCheck, pause: Pause, edit: Edit,
};

const ROLE_COLOR = {
  parent: '#0F766E', office: '#1D4ED8', counsellor: '#7C3AED',
  rector: '#C89B3C', system: '#64748B',
};

const fmt = (iso) => {
  const d = new Date(iso);
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export function Timeline({ events = [] }) {
  const sorted = [...events].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  if (!sorted.length) return <p className="text-sm text-[#64748B]">No timeline activity yet.</p>;
  return (
    <ol className="relative" data-testid="applicant-timeline">
      {sorted.map((e, i) => {
        const Icon = ICONS[e.icon] || Activity;
        const color = ROLE_COLOR[e.role] || '#64748B';
        return (
          <li key={e.id || i} className="relative flex gap-4 pb-6 last:pb-0 animate-fade-up" style={{ animationDelay: `${i * 30}ms` }}>
            {i !== sorted.length - 1 && <span className="absolute left-[15px] top-8 bottom-0 w-px bg-[#E2E8F0]" />}
            <span className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 bg-white"
              style={{ borderColor: color }}>
              <Icon size={15} style={{ color }} />
            </span>
            <div className="flex-1 pt-0.5">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <span className="text-sm font-semibold text-[#172033]">{e.action}</span>
                <span className="rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                  style={{ color, backgroundColor: `${color}14` }}>{e.role}</span>
              </div>
              <p className="mt-0.5 text-sm text-[#475569]">{e.detail}</p>
              <p className="mt-1 text-xs text-[#94A3B8]">{e.user} · {fmt(e.timestamp)}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
